module.exports = {
  plus: [{
    text: '错误',
    score: 1,
    color: 1
  }, {
    text: '失准',
    score: 2,
    color: 2
  }, {
    text: '普通',
    score: 3,
    color: 3
  }, {
    text: '准确',
    score: 4,
    color: 4
  }, {
    text: '精确',
    score: 5,
    color: 5
  }],
  minus: [{
    text: '错误',
    score: 5,
    color: 1
  }, {
    text: '失准',
    score: 4,
    color: 2
  }, {
    text: '普通',
    score: 3,
    color: 3
  }, {
    text: '准确',
    score: 2,
    color: 4
  }, {
    text: '精确',
    score: 1,
    color: 5
  }]
};